'use strict';

var _ = require('lodash');
function ConfigurationLegAssignmentService($q, restangular, $http) {
  var rulesAPI = restangular.service('configuration').one('hep').one('legentityassignment');
  function saveConfigurationLegAssignment(entities) {
    var payloadEntity = _.transform(entities, function (result, item) {
      var newEntity = _.clone(item);
      delete newEntity._old;
      delete newEntity._original;
      delete newEntity.originalRowId;
      delete newEntity._links;
      if (newEntity.origin !== undefined) {
        newEntity.hepKey = newEntity.hepKey || '';
      }
      result.push(newEntity);
    });
    return rulesAPI.customPUT(payloadEntity);
  }
  function remove(data) {
    _.forEach(data, function (assignment) {
      delete assignment.uid;
      delete assignment._old;
      delete assignment._original;
      delete assignment.originalRowId;
      delete assignment._links;
    });
    return $http({
      method: 'DELETE',
      url: rulesAPI.getRestangularUrl(),
      data: data,
      headers: {
        'Content-Type': 'application/json;charset=UTF-8'
      }
    });
  }
  return {
    save: saveConfigurationLegAssignment,
    remove: remove
  };
}
ConfigurationLegAssignmentService.$inject = ['$q', 'Restangular', '$http'];
module.exports = ConfigurationLegAssignmentService;